import { StructureStepLogTable } from "components/Tables/StructureStepLogTable/StructureStepLogTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/validation/")({
    component: ValidationStepLogPage,
    staticData: {
        permissions: [PermissionEnum.StepLogStructuresView],
        showInSideMenu: false,
        label: "pages.log.validation.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.validation.title"),
        };
    },
});

function ValidationStepLogPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <StructureStepLogTable />
        </TenantPage>
    );
}
